import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { TransactionModel } from './partners.model';
import { TransactionConst } from './const';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { PartnersListComponent } from './partners-list.component';
import { PartnersService } from './partners.service';
import { Utils } from '../../../../shared/utils';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-partners-dialog-t',
    templateUrl: './partners-dialog-t.component.html',
    styleUrls: ['./partners-dialog-t.component.css'],
    standalone: false
})

export class PartnersDialogTComponent implements OnInit {
  public partnerSelected = this.data['PartnerSelected'];
  uid: number = this.data.uid;
  error_msg: string;
  error: boolean = false;
  dataSource: TransactionModel;
  dataSourceTransaction: TransactionModel[] = [];
  ready: boolean = false;
  partnersName: any = this.data.accountingAccount.nameOrBusinessName;
  partnersAccount118: any = this.data.accountingAccount.accountingModels118;
  totalContributedPartners: number = 0;
  totalReturnedPartners: number = 0;
  totalPartners: number = 0;
  name: string;
  headerTableP: any[] = TransactionConst.headerTable;

  cuentaContable = null;

  accountNumber = null;

  public numberAccountingAccount: string = "";

  constructor(
    public dialogRef: MatDialogRef<PartnersListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public partnersService: PartnersService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.ready = true;
  }

  onChangeAccount() {
    this.getData();

    if (this.partnerSelected.accountingModels118Id == this.accountNumber) {
      this.numberAccountingAccount = this.partnerSelected.accountingModels118;
    }

    if (this.partnerSelected.accountingModels551Id == this.accountNumber) {
      this.numberAccountingAccount = this.partnerSelected.accountingModels551;
    }

  }

  getData() {
    this.ready = false;

    this.partnersService.partnersTransactionList(this.data.uid).then(response => {

      this.dataSourceTransaction = response;

      this.dataSourceTransaction = response.filter(c => c.accountingModelsId == this.accountNumber);

      const Aportacion = this.dataSourceTransaction.filter(item => item.transactionType === false);
      const Devolucion = this.dataSourceTransaction.filter(item => item.transactionType === true);

      // Función para obtener la suma de 'amount' en un arreglo de objetos
      const obtenerSumaAmount = (arreglo) => {
        return arreglo.reduce((total, item) => total + item.amount, 0);
      };

      // Obtener el valor total de 'amount' en Aportacion y Devolucion
      const totalAportacion = obtenerSumaAmount(Aportacion);
      const TotalDevolucion = obtenerSumaAmount(Devolucion);

      this.totalContributedPartners = Utils.GetValueWithDecimals(TotalDevolucion);
      this.totalReturnedPartners = Utils.GetValueWithDecimals(totalAportacion);
      this.totalPartners = Utils.GetValueWithDecimals(this.totalContributedPartners - this.totalReturnedPartners);
      this.ready = true;
    }).catch(x => {
      this.ready = true;
      this.error = true;
      this.error_msg = x.error.message;
    });
  }

  getExcel() {
    this.partnersService.getExcelT(this.data.uid).then(response => {
      FileSaver.saveAs(response, Utils.GetExcelName("Socio_T_" + this.name));
    })
  }

  displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
